import React from "react";
import PropTypes from "prop-types";
import { Button, Flex } from "orcs-design-system";
import styled from "styled-components";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

const PromptButton = styled(Button)`
  background: white;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  color: ${(props) => props.theme.colors.greyDarkest};
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.colors.greyLightest};
    border-color: ${(props) => props.theme.colors.grey};
  }
`;

/**
 * SuggestedPrompts component - displays suggested prompt buttons
 * @param {Object} props
 * @param {Function} props.onPromptSelect - Callback when a prompt is selected
 */
const SuggestedPrompts = ({ onPromptSelect }) => {
  const { enableAIDashboards } = useWorkspaceFeatureFlags();

  const suggestedPrompts = [
    "What are my team objectives?",
    enableAIDashboards
      ? "Provide a /dashboard of the team(s) I am in"
      : "Provide an overview of the team(s) I am in",
    "How are we tracking against our Principles?",
  ];

  return (
    <Flex flexDirection="column" alignItems="center" gap="r" mt="r">
      {/* Suggested Prompt Buttons */}
      <Flex flexWrap="wrap" justifyContent="center" gap="xs" maxWidth="500px">
        {suggestedPrompts.map((prompt) => (
          <PromptButton
            key={prompt}
            variant="ghost"
            onClick={() => onPromptSelect(prompt)}
            small
            mb="r"
          >
            {prompt}
          </PromptButton>
        ))}
      </Flex>
    </Flex>
  );
};

SuggestedPrompts.propTypes = {
  onPromptSelect: PropTypes.func.isRequired,
};

export default SuggestedPrompts;
